module.exports = __webpack_public_path__ + "static/img/43.173c794b.png";